<template>
  <div class="container box">
    <h2>
      ぴたコインで<br>
      無料ビットコインをゲット
    </h2>
    <p class="note">
      明日のビットコイン価格が上がるか下がるかを<br>
      予想するだけでビットコインがもらえます
    </p>
    <Ad1/>
  </div>
</template>

<script>
import Ad1 from './ad/Ad1'

export default {
  name: 'WhatPitacoin',
  components: {
    Ad1
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{
  text-align: center;
  color: #333;
  font-size: 40px;
}
.note{
  text-align: center;
  font-size: 20px;
  color: #999;
}
@media all and (max-width: 480px) {
  h2{
    font-size: 22px;
  }
  .note{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WhatPitacoin.vue